import { NodeModel } from '@minoru/react-dnd-treeview';
import {
    WorkshiftSchedulingModel,
    WorkshiftsListModel,
} from '../../models/workshifts/workshif-scheduling/workshiftSchedulingList.model';
import { getChildNodes, getDatesBetweenDates } from '../../utils';

type Props = {
    grid: any;
    treeEmployees: NodeModel[];
    startDate: string;
    endDate: string;
    workshiftShedulingList: WorkshiftsListModel;
    getWorkshiftScheduling: (
        date: string | number,
        employeeID: string | number,
        workshiftShedulingList: WorkshiftsListModel
    ) => WorkshiftSchedulingModel | undefined;
    openAssociateTimeAttendanceEvents?: (
        startDate: string | number,
        endDate: string | number,
        employee: NodeModel[],
        workshiftId: WorkshiftSchedulingModel[]
    ) => void;
};

export const controllerCreateTimeAttendanceEventsModal = ({
    grid,
    treeEmployees,
    startDate,
    endDate,
    workshiftShedulingList,
    openAssociateTimeAttendanceEvents: openAssociateMarkings,
    getWorkshiftScheduling,
}: Props) => {
    let row1 = grid.selectedRanges[0].row;
    let row2 = grid.selectedRanges[0].row2;
    let col1 = grid.selectedRanges[0].col - 2;
    let col2 = grid.selectedRanges[0].col2 - 2;

    if (row1 > row2) {
        let aux = row1;
        row1 = row2;
        row2 = aux;
    }

    if (col1 > col2) {
        let aux = col1;
        col1 = col2;
        col2 = aux;
    }

    let initDate = getDatesBetweenDates(startDate, endDate)[col1];
    let lastDate = getDatesBetweenDates(startDate, endDate)[col2];

    let selectedEmployees = getChildNodes(treeEmployees).slice(row1, row2 + 1);

    let dates = getDatesBetweenDates(initDate, lastDate);

    let workshiftsFloating: WorkshiftSchedulingModel[] | undefined = [];
    let workshiftsList = [];

    for (let emp = 0; emp < selectedEmployees.length; emp++) {
        for (let date = 0; date < dates.length; date++) {
            let workshiftId = getWorkshiftScheduling(
                dates[date],
                selectedEmployees[emp].id,
                workshiftShedulingList
            );

            if (workshiftId?.workshift?.isFloating) {
                workshiftsFloating.push(workshiftId);
            }

            if (workshiftId) {
                workshiftsList.push(workshiftId);
            }
        }
    }

    if (
        initDate === lastDate &&
        selectedEmployees.length == 1 &&
        openAssociateMarkings
    ) {
        openAssociateMarkings(initDate, lastDate, selectedEmployees, workshiftsList);
    }
};
